
import { ElCol, ElDivider, ElMain, ElRow } from 'element-plus';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Article',
    components: { ElCol, ElDivider, ElMain, ElRow }
});
